import React, { Component } from 'react';
import { connect } from 'react-redux';
import HistoryRender from './children/HistoryRender';
import {
  requsetGetHistoryiles,
  requsetDelHistoryiles,
  requsetGetAllType,
} from '@/views/account/api/apiHistory';
import { GAPersonalHistoryPageDisplay } from '@/views/account/ga/personalCenter';
import Utils from '@/utils';
import BasicModal from '@/components/basicModal/BasicModal';
import '@/views/account/assets/history.scss';
import { withTranslation } from 'react-i18next';
import actions from '@/views/account/redux/action';
import { Spin, Modal } from 'antd';
import cartUrl from '@/views/account/utils/cartUrl';
import sentGAEvent from '../../../../ga/index';
import { urlToFunction } from '@/views/account/utils/urlToFunction';
class History extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditing: false,
      selectAll: false,
      selectGuidList: [], //批量删除选中的文件
      files: [],
      job_ids: [],
      //删除确认弹窗信息
      basicModalObj: {
        visible: false,
        content: this.props.t('deleteTips'),
        onCancel: () => {
          const basicModalObj = { ...this.state.basicModalObj };
          basicModalObj.visible = false;
          this.setState({
            basicModalObj,
          });
        },
        onOk: () => {
          const basicModalObj = { ...this.state.basicModalObj };
          basicModalObj.visible = false;
          this.setState({
            basicModalObj,
          });
          this.handleDeleteFn();
        },
      },
      tabList: {},
      activeType: 'All',
      activeSubType: 0,
      isShowFilter: false,
      loading: false,
      isModalOpen: false,
      selectMediaInfo: {}, // 选中的多媒体文件
      purchaseUrl: '/purchase',
    };
  }
  componentDidMount() {
    if (window.location.href.indexOf('track[type]') >= 0) {
      // eslint-disable-next-line no-restricted-globals
      const urlParam = this.getUrlParam(location.href);
      const url = `&track[type]=${urlParam['track[type]']}&track[sid]=${urlParam['track[sid]']}&track[func]=${urlParam['track[func]']}&track[reason]=${urlParam['track[reason]']}&track[host]=${urlParam['track[host]']}&track[platform]=${urlParam['track[platform]']}&track[ab]=${urlParam['track[ab]']}&track[channel]=${urlParam['track[channel]']}&track[discount]=${urlParam['track[discount]']}`;
      this.setState({
        purchaseUrl: this.state.purchaseUrl + '?' + url,
      });
    } else {
      setTimeout(() => {
        const track = cartUrl('');
        let __s = Object.keys(track)
          .map((v) => {
            return `track[${v}]=${track[v]}`;
          })
          .join('&');
        this.setState({
          purchaseUrl: this.state.purchaseUrl + '?' + __s,
        });
      }, 1000);
    }
    this.props.onHistoryObjChange([]);
    this.getAll();
    this.handleGetHistoryiles({
      data: {
        type: 'All',
      },
    });
    sentGAEvent({
      category: 'EnterPage',
      action: 'V2_EnterPage',
      label: 'V2FilesPage',
    });
  }

  getUrlParam = (url) => {
    // 通过 ? 分割获取后面的参数字符串
    let urlStr = url.split('?')[1];
    // 创建空对象存储参数
    let obj = {};
    // 再通过 & 将每一个参数单独分割出来
    let paramsArr = urlStr.split('&');
    for (let i = 0, len = paramsArr.length; i < len; i++) {
      // 再通过 = 将每一个参数分割为 key:value 的形式
      let arr = paramsArr[i].split('=');
      obj[arr[0]] = arr[1];
    }
    return obj;
  };

  setMediaInfo = (obj) => {
    if ((obj.media_type === 'Video' || obj.media_type === 'Audio') && obj.url) {
      this.setState({
        isModalOpen: true,
        selectMediaInfo: obj,
      });
    }
  };
  onCancelModel = () => {
    this.setState({
      isModalOpen: false,
      selectMediaInfo: {},
    });
  };
  //获取所有的tab
  getAll = () => {
    requsetGetAllType()
      .then((res) => {
        if (res.code === 200) {
          this.setState({
            tabList: res.data,
          });
        } else {
          this.setState({
            tabList: {},
          });
        }
      })
      .catch((err) => {
        this.setState({
          tabList: {},
        });
      });
  };
  //
  //获取文件
  handleGetHistoryiles = (obj) => {
    this.setState({
      loading: true,
    });
    requsetGetHistoryiles(obj)
      .then((res) => {
        this.setState({
          loading: false,
        });
        if (res.code === 200) {
          console.log('res', res);
          if (res.data.history_files) {
            this.props.onHistoryObjChange(
              res.data.history_files ? res.data.history_files : []
            );
            this.setState({
              selectGuidList: [],
              selectAll: false,
            });
            GAPersonalHistoryPageDisplay(
              res.data.history_files ? res.data.history_files.length : 0
            );
          } else {
            this.props.onHistoryObjChange([]);
            this.setState({
              selectGuidList: [],
              selectAll: false,
            });
            GAPersonalHistoryPageDisplay(0);
          }
        } else {
          this.props.onHistoryObjChange([]);
          this.setState({
            selectGuidList: [],
            selectAll: false,
          });
          GAPersonalHistoryPageDisplay(0);
        }
      })
      .catch((err) => {
        this.setState({
          loading: false,
        });
        console.log(err);
      });
  };
  //删除切换
  editingChange = (val) => {
    this.setState({
      isEditing: val,
      selectGuidList: [],
      selectAll: false,
    });
  };
  //全选
  handleSelectAll = (e) => {
    const files = this.props.historyObj;
    let selectGuidList = [];
    if (e.target.checked) {
      selectGuidList = files.map((item) => item.job_id);
    } else {
      selectGuidList = [];
    }
    this.setState({
      selectAll: e.target.checked,
      selectGuidList: selectGuidList,
    });
  };
  //批量删除时选择文件
  handleSelectClick = (file) => {
    let { selectGuidList } = this.state;
    const files = this.props.historyObj;
    if (selectGuidList.some((item) => item == file.job_id)) {
      selectGuidList = selectGuidList.filter((item) => item != file.job_id);
    } else {
      selectGuidList.push(file.job_id);
    }
    this.setState({
      selectGuidList: selectGuidList,
    });
    if (selectGuidList.length == 0) {
      this.setState({
        selectAll: false,
      });
    } else if (files.length == selectGuidList.length) {
      this.setState({
        selectAll: true,
      });
    }
  };

  handleMultipleSelect = (file) => {
    console.log(file);
    let { selectGuidList } = this.state;

    selectGuidList.push(file.job_id);

    this.setState({
      isEditing: true,
      selectGuidList: selectGuidList,
    });
  };
  handleDelete = (file) => {
    let { selectGuidList } = this.state;
    if (file && file.job_id) {
      this.setState({
        job_ids: [file.job_id],
      });
    } else {
      if (selectGuidList <= 0) return;
      this.setState({
        job_ids: selectGuidList,
      });
    }
    console.log(file, selectGuidList);
    const basicModalObj = { ...this.state.basicModalObj };
    basicModalObj.visible = true;
    this.setState({
      basicModalObj,
    });
  };
  //删除
  handleDeleteFn = () => {
    requsetDelHistoryiles({
      body: JSON.stringify({ job_ids: this.state.job_ids }),
    })
      .then((res) => {
        if (res.code === 200) {
          this.handleGetHistoryiles({
            data: {
              type: 'All',
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  convertToHMS = (timestamp) => {
    // 获取当前时间的时间戳
    let now = new Date().getTime() / 1000;

    // 计算时间差，取绝对值
    let diff = Math.abs(now - timestamp);
    console.log('diff', diff, timestamp, now);
    // 计算时、分、秒
    let day = Math.floor(diff / 86400);
    let hours = Math.floor((diff % 86400) / 3600);
    let minutes = Math.floor(((diff % 86400) % 3600) / 60);
    if (timestamp === 0) {
    }
    // 格式化为时分秒的格式
    let formattedTime;
    if (diff >= 86400) {
      formattedTime = day + 'D' + hours + 'H' + minutes + 'M';
    } else if (diff >= 3600 && diff < 86400) {
      formattedTime = hours + 'H' + minutes + 'M';
    } else {
      formattedTime = minutes + 'M';
    }
    if (timestamp === 0) {
      formattedTime = '1D';
    }

    return formattedTime;
  };
  urlName = (file) => {
    if (file.media_job_type && urlToFunction[file.media_job_type]) {
      return urlToFunction[file.media_job_type];
    } else {
      return {
        url: 'https://online.hitpaw.com/',
        name: 'hitPaw',
        label: 'other',
      };
    }
  };
  //下载
  handleDownloadClick = (item) => {
    console.log(item);
    sentGAEvent({
      category: 'DownloadClick',
      action: 'V2_DownloadClick',
      label: `${item.media_type}_${this.convertToHMS(item.created_at)}`,
    });
    let labelValue = this.urlName(item);
    sentGAEvent({
      category: 'DownloadStart',
      action: `${labelValue.label}_DownloadStart`,
      label: 'Null',
    });
    Utils.downloadFile(item, item.file_name);
  };

  // 切换过滤条件
  changeSunType = (item) => {
    this.setState({
      isShowFilter: false,
      activeSubType: item,
    });
  };

  // 切换显示过滤条件
  changeFilter = () => {
    this.setState({
      isShowFilter: !this.state.isShowFilter,
    });
  };

  // 切换tab类型
  changeType = (item) => {
    this.setState({
      isShowFilter: false,
      activeSubType: '',
      activeType: item,
    });
  };

  render() {
    return (
      <div className='historyFile'>
        <Spin spinning={this.state.loading}>
          <HistoryRender
            subscription={this.props.subscription}
            isEditing={this.state.isEditing}
            selectAll={this.state.selectAll}
            editingChange={this.editingChange}
            files={this.props.historyObj}
            selectGuidList={this.state.selectGuidList}
            tabList={this.state.tabList}
            activeType={this.state.activeType}
            activeSubType={this.state.activeSubType}
            isShowFilter={this.state.isShowFilter}
            purchaseUrl={this.state.purchaseUrl}
            changeSunType={this.changeSunType}
            changeType={this.changeType}
            changeFilter={this.changeFilter}
            handleSelectAll={this.handleSelectAll}
            handleSelectClick={this.handleSelectClick}
            handleDelete={this.handleDelete}
            handleDownloadClick={this.handleDownloadClick}
            setMediaInfo={this.setMediaInfo}
            handleMultipleSelect={this.handleMultipleSelect}
          />
        </Spin>
        <BasicModal {...this.state.basicModalObj} />

        <Modal
          getContainer={false}
          className='modalOpen'
          visible={this.state.isModalOpen}
          title={null}
          footer={null}
          centered
          onCancel={this.onCancelModel}
        >
          {Object.keys(this.state.selectMediaInfo).length >= 1 ? (
            this.state.selectMediaInfo.media_type === 'Video' ? (
              <video
                controls={true}
                autoPlay='autoplay'
                className='video'
                src={this.state.selectMediaInfo.url}
                poster={this.state.selectMediaInfo.thumbnail_urls[0]}
              ></video>
            ) : (
              <div className='audioBox'>
                <audio
                  controls={true}
                  autoPlay='autoplay'
                  src={this.state.selectMediaInfo.url}
                ></audio>
              </div>
            )
          ) : (
            ''
          )}
        </Modal>
      </div>
    );
  }
}

const mapStateToPropos = (state) => ({
  subscription: state.account.subscription,
  historyObj: state.account.historyObj,
});
const mapDispatchToProps = (dispatch) => ({
  onHistoryObjChange: (historyObj) =>
    dispatch(actions.onHistoryObjChange(historyObj)),
});
export default connect(
  mapStateToPropos,
  mapDispatchToProps
)(withTranslation(['personalCenterHistory', 'common'])(History));
